import axios from 'axios'
import baseURL from '../config/url';
export default axios.create(
    {
    baseURL: baseURL
});

